<template>
    <v-row class="text-center mt-10 pa-0" justify="center">
        <v-col cols="4">
            <div>Срок займа</div>
            <div>
                {{ $anketa.term.value }} дней
            </div>
        </v-col>
        <v-col cols="4">
            <div>Размер займа</div>
            <div>
                {{ $anketa.initialPayment.value }} ₽
            </div>
        </v-col>
        <!-- <v-col cols="4">
            <div>Ежемесячный платеж</div>
            <div>
                700 ₽
            </div>
        </v-col> -->
    </v-row>
</template>

<script>
export default  {

}
</script>